import {useRef, useCallback} from 'react';
import {requestWakeLock, releaseWakeLock} from '@Utils/screen-wake-lock-api';

interface UseWakeLockReturn {
  lock: () => Promise<void>;
  unlock: () => Promise<void>;
  isLocked: () => boolean;
}

export const useWakeLock = (): UseWakeLockReturn => {
  const wakeLockActiveRef = useRef<boolean>(false);

  const acquireScreenWakeLock = useCallback(async (): Promise<void> => {
    if (!wakeLockActiveRef.current) {
      wakeLockActiveRef.current = await requestWakeLock();
    }
  }, []);

  const releaseScreenWakeLock = useCallback(async (): Promise<void> => {
    if (wakeLockActiveRef.current) {
      await releaseWakeLock();
      wakeLockActiveRef.current = false;
    }
    return Promise.resolve();
  }, []);

  const isLocked = useCallback((): boolean => {
    return wakeLockActiveRef.current;
  }, []);

  return {
    lock: acquireScreenWakeLock,
    unlock: releaseScreenWakeLock,
    isLocked,
  };
};
